/**
 * ドラクエ9 宝の地図フロアマップの領域を分割する仕切り棒の情報を保持するクラス
 * @class Divider
 */
class Divider {
  /**
   * @type {number} 仕切り棒の始点のx座標
   */
  private _startX: number = 0

  /**
   * @type {number} 仕切り棒の始点のy座標
   */
  private _startY: number = 0

  /**
   * @type {number} 仕切り棒の終点のx座標
   */
  private _endX: number = 0

  /**
   * @type {number} 仕切り棒の終点のy座標
   */
  private _endY: number = 0

  /**
   * @type {number} 分割された領域の要素番号1
   */
  private _areaIndex1: number = 0

  /**
   * @type {number} 分割された領域の要素番号2
   */
  private _areaIndex2: number = 0

  /**
   * @type {number} 仕切り棒の方向（1：横、2：縦）
   */
  private _direction: number = 0

  /**
   * 仕切り棒の始点のx座標のgetter
   * @returns {number} 仕切り棒の始点のx座標
   */
  public get startX(): number {
    return this._startX
  }

  /**
   * 仕切り棒の始点のx座標のsetter
   * @param {number} value 仕切り棒の始点のx座標
   */
  public set startX(value: number) {
    this._startX = value
  }

  /**
   * 仕切り棒の始点のy座標のgetter
   * @returns {number} 仕切り棒の始点のy座標
   */
  public get startY(): number {
    return this._startY
  }

  /**
   * 仕切り棒の始点のy座標のsetter
   * @param {number} value 仕切り棒の始点のy座標
   */
  public set startY(value: number) {
    this._startY = value
  }

  /**
   * 仕切り棒の終点のx座標のgetter
   * @returns {number} 仕切り棒の終点のx座標
   */
  public get endX(): number {
    return this._endX
  }

  /**
   * 仕切り棒の終点のx座標のsetter
   * @param {number} value 仕切り棒の終点のx座標
   */
  public set endX(value: number) {
    this._endX = value
  }

  /**
   * 仕切り棒の終点のy座標のgetter
   * @returns {number} 仕切り棒の終点のy座標
   */
  public get endY(): number {
    return this._endY
  }

  /**
   * 仕切り棒の終点のy座標のsetter
   * @param {number} value 仕切り棒の終点のy座標
   */
  public set endY(value: number) {
    this._endY = value
  }

  /**
   * 分割された領域の要素番号1のgetter
   * @returns {number} 分割された領域の要素番号1
   */
  public get areaIndex1(): number {
    return this._areaIndex1
  }

  /**
   * 分割された領域の要素番号1のsetter
   * @param {number} value 分割された領域の要素番号1
   */
  public set areaIndex1(value: number) {
    this._areaIndex1 = value
  }

  /**
   * 分割された領域の要素番号2のgetter
   * @returns {number} 分割された領域の要素番号2
   */
  public get areaIndex2(): number {
    return this._areaIndex2
  }

  /**
   * 分割された領域の要素番号2のsetter
   * @param {number} value 分割された領域の要素番号2
   */
  public set areaIndex2(value: number) {
    this._areaIndex2 = value
  }

  /**
   * 仕切り棒の方向のgetter
   * @returns {number} 仕切り棒の方向
   */
  public get direction(): number {
    return this._direction
  }

  /**
   * 仕切り棒の方向のsetter
   * @param {number} value 仕切り棒の方向
   */
  public set direction(value: number) {
    this._direction = value
  }

  /**
   * 仕切り棒の始点・終点の座標を一括指定
   * @param {number} startX 仕切り棒の始点のx座標
   * @param {number} startY 仕切り棒の始点のy座標
   * @param {number} endX 仕切り棒の終点のx座標
   * @param {number} endY 仕切り棒の終点のy座標
   */
  public setCoordinate(startX: number, startY: number, endX: number, endY: number): void {
    this._startX = startX
    this._startY = startY
    this._endX = endX
    this._endY = endY
  }
}

export { Divider }
